import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ManualPaymentService {

  constructor(private http: HttpClient) { }

  getAll(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.MANUAL_PAYMENTS, { params })
      .pipe(catchError(errorHandl));
  }

  createBulk(payload: any) {
    return this.http.post(urls.API_URL + urls.MANUAL_PAYMENTS + '/bulk', payload)
      .pipe(catchError(errorHandl));
  }

  create(payload: any) {
    return this.http.post(urls.API_URL + urls.MANUAL_PAYMENTS, payload)
      .pipe(catchError(errorHandl));
  }

}
